// Used in singular-assignment-stimulus-activity-submit.component.html, view-assignment.component.html, composite-tasks.component.html,
// activity-preview-dialog.component.html, and composite-assignment-submit.component.html

// Angular
import { Component, Input, OnInit } from "@angular/core";

// Services/Types/Helpers
import { ProcessStimuliHelper } from "#helpers/process-stimuli.helper";
// RXJS/Store
import { CustomActivity } from "@carnegie-learning/cure-types";
import { CustomActivityService } from "@carnegie-learning/data-access-angular-passport";
import { Observable } from "rxjs";

@Component({
    selector: "stimulus-activity",
    templateUrl: "./stimulus-activity.component.html",
    styleUrls: [
        "./stimulus-activity.component.scss",
        "../../../../styles/shared-styles.scss",
    ],
    standalone: false
})
export class StimulusActivityComponent implements OnInit {
    stimulus_file$: Observable<string>;
    stimulus_url: any;
    @Input() stimulus: CustomActivity;
    @Input() moduleID: number;

    constructor(
        private processStimuliHelper: ProcessStimuliHelper,
        private customActivityService: CustomActivityService
    ) {}

    ngOnInit() {
        if (this.stimulus) {
            if (this.stimulus.file) {
                this.stimulus_file$ = this.customActivityService.getFileUrl(
                    this.stimulus
                );
            }
            if (this.stimulus.url) {
                this.stimulus_url =
                    this.processStimuliHelper.processStimuliLink_Lesson(
                        this.stimulus.url,
                        true
                    );
            }
        }
    }

    getCompositeTaskType() {
        if (this.stimulus.stimuli) {
            return this.stimulus.stimuli.slice(
                0,
                this.stimulus.stimuli.indexOf(":")
            );
        } else {
            return 0;
        }
    }

    getModuleTaskType(stimuli: string) {
        if (stimuli) {
            return stimuli.slice(0, stimuli.indexOf(":"));
        } else {
            return 0;
        }
    }

    generateStimuliLinkArray(rawStimuli: string) {
        return this.processStimuliHelper.generateStimuliLinkArray(rawStimuli);
    }

    processStimuliLink_Module(stimuli: string) {
        return this.processStimuliHelper.processStimuliLink_Module(
            stimuli,
            this.moduleID,
            false
        );
    }

    processStimuliLink_Url() {
        return this.processStimuliHelper.processStimuliLink_Lesson(
            this.stimulus.url,
            true
        );
    }

    getMediaTypeFromFile(file: string) {
        if (!file) {
            return null;
        }
        if (
            file.includes(".jpg") ||
            file.includes(".jpeg") ||
            file.includes(".png") ||
            file.includes(".bmp") ||
            file.includes(".gif")
        ) {
            return "image";
        } else if (
            file.includes(".mov") ||
            file.includes(".mp4") ||
            file.includes(".webm")
        ) {
            return "video";
        }

        return "other";
    }
}
